import { useLocation } from 'react-router-dom';

/**
 * @example //*http://localhost:65534/?walmartCallbackUri=https://login.account.walmart.com/authorize&clientType=supplier
 * @returns
 */
export const useCheckIsWalmartAuthorization = () => {
  const location = useLocation();
  const search = location?.search;

  let authorizeWalmart = {
    isWalmartAuthorize: false,
    walmartLoginUrl: null,
    walmartSearchQuery: null,
  };

  if (search?.includes('walmartCallbackUri=')) {
    authorizeWalmart.isWalmartAuthorize = true;
    authorizeWalmart.walmartLoginUrl = search?.split(
      'walmartCallbackUri='
    )?.[1];
    authorizeWalmart.walmartSearchQuery = search;

    window['authorizeWalmart'] = authorizeWalmart;
  }

  return authorizeWalmart;
};

export const getWalmartAuthorizationParams = (request) => {
  const url = new URL(request.url);
  const search = url.search;

  let authorizeWalmart = {
    isWalmartAuthorize: false,
    walmartLoginUrl: null,
    walmartSearchQuery: null,
  };

  if (search?.includes('walmartCallbackUri=')) {
    authorizeWalmart.isWalmartAuthorize = true;
    authorizeWalmart.walmartLoginUrl = search?.split(
      'walmartCallbackUri='
    )?.[1];
    authorizeWalmart.walmartSearchQuery = search;

    // Store in global if needed (though not recommended)
    if (typeof window !== 'undefined') {
      window['authorizeWalmart'] = authorizeWalmart;
    }
  }

  return authorizeWalmart;
};
